module.exports = __webpack_public_path__ + "img/dataset_filter_dialog.5da6c7d5.png";